import type { OptionDefinition } from "../types.ts";

export const phoneOptions: OptionDefinition[] = [
  {
    key: "enablePhone",
    type: "boolean",
    default: false,
    label: "Enable Superslides app connection",
    tab: "phone",
  },
];
